import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "container" }

import { computed, inject, onMounted, reactive, ref, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { updateAuctionListeners } from "@/utils/websockets";
  import Catalog from "@/components/Catalog.vue";
  import LotMainInfo from "@/components/LotMainInfo.vue";
  import CustomHeader from "@/components/layouts/CustomHeader.vue";
  import ActionsTab from "@/components/action-block/ActionsTab.vue";
  import Preloader from "@/components/_partials/Preloader.vue";
  import LotMainSeller from "@/components/seller/LotMainSeller.vue";
  import apiClient from "@/services/api";
  import Toast from "primevue/toast";
  import { useToast } from "primevue/usetoast";
  import HotKeysService from "@/components/seller/HotKeysService.vue";
  import router from "@/router";
  import LiveAlertNotification from "@/components/_partials/LiveAlertNotification.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const toast = useToast();
  const emitter = inject("emitter");

  const isDataLoaded = computed(() => auctionStore.translations && auctionStore.auction?.id);
  const changeStatusTimer = ref<null | number>(null);
  const state = reactive({
    alert: {
      intervalId: null as number | null,
      alertMessage: "" as string | null,
      leftBefore: null as number | null
    }
  });

  watch(
    () => auctionStore.pageIsActive,
    (nv, ov) => {
      if (auctionStore.auction.id && !auctionStore.user?.is_admin) {
        if (changeStatusTimer.value) {
          clearTimeout(changeStatusTimer.value);
          changeStatusTimer.value = null;
        }
        if (ov !== nv) {
          changeStatusTimer.value = setTimeout(() => {
            const status = nv ? "active" : "inactive";
            apiClient.post(`/live/user/${auctionStore.auction.id}/${status}`);
          }, 2000);
        }
      }
    }
  );

  onMounted(async () => {
    addPageStatusListeners();

    window.Echo.connector.pusher.connection.bind("connecting", () => {
      console.log("connecting...");
    });
    window.Echo.connector.pusher.connection.bind("connected", (payload: any) => {
      console.log("connected!", payload);
      loadAuction();
    });

    auctionStore.initFilter();
  });

  const loadAuction = async () => {
    await auctionStore.fetchAuction().then(() => {
      setTitle();

      updateAuctionListeners(toast, emitter);
      auctionStore.fetchLots();

      apiClient.post(`/live/user/${auctionStore.auction.id}/active`);
    });
  };

  const addPageStatusListeners = () => {
    document.addEventListener("visibilitychange", () => {
      auctionStore.$patch({
        pageIsActive: !document.hidden
      });
    });

    setInterval(() => {
      auctionStore.$patch({
        pageIsActive: document.hasFocus()
      });
    }, 1000);
  };

  watch(
    () => auctionStore.pageIsActive,
    (nv, ov) => {
      if (auctionStore.auction.id && !auctionStore.user?.is_admin) {
        if (changeStatusTimer.value) {
          clearTimeout(changeStatusTimer.value);
          changeStatusTimer.value = null;
        }
        if (ov !== nv) {
          changeStatusTimer.value = setTimeout(() => {
            const status = nv ? "active" : "inactive";
            apiClient.post(`/live/user/${auctionStore.auction.id}/${status}`);
          }, 2000);
        }
      }
      if (ov !== nv && nv && state.alert.intervalId) {
        clearInterval(state.alert.intervalId);
        state.alert.leftBefore = null;
        state.alert.alertMessage = null;
        setTitle();
      }
    }
  );

  emitter?.on("auction:lot-alert", (data: { content: string }) => {
    if (!auctionStore.pageIsActive) {
      state.alert.alertMessage = data.content;

      if (state.alert.intervalId) {
        clearInterval(state.alert.intervalId);
      }

      state.alert.intervalId = setInterval(() => {
        if (document.title === state.alert.alertMessage) {
          setTitle();
        } else if (state.alert.alertMessage) {
          document.title = state.alert.alertMessage;
        }
      }, 1000);
    }
  });

  const setTitle = () => {
    document.title = `${auctionStore.auction.title} - ${process.env.VUE_APP_APP_NAME}`;
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isDataLoaded.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(CustomHeader),
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (isDataLoaded.value)
                ? (_openBlock(), _createElementBlock("section", {
                    key: 0,
                    class: _normalizeClass([!_unref(auctionStore).user?.is_admin ? 'live-auction' : 'live-auction-seller'])
                  }, [
                    (_unref(auctionStore).user?.is_admin)
                      ? (_openBlock(), _createBlock(LotMainSeller, { key: 0 }))
                      : (_openBlock(), _createBlock(LotMainInfo, { key: 1 })),
                    _createVNode(Catalog),
                    _createVNode(ActionsTab)
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock(Preloader, {
          key: 1,
          class: "load-app"
        })),
    (isDataLoaded.value && _unref(auctionStore).user?.is_admin)
      ? (_openBlock(), _createBlock(HotKeysService, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(LiveAlertNotification),
    _createVNode(_unref(Toast))
  ], 64))
}
}

})